import React from 'react';

import BreadcrumbsNav from 'components/BreadcrumbsNav/BreadcrumbsNav';

import { usePicklistDetailsSelector } from 'hooks/Picklist';

export const BreadCrumbs = () => {
  const { currentPicklist } = usePicklistDetailsSelector();
  const { name } = currentPicklist;

  if (!name) return null;

  return <BreadcrumbsNav itemsArray={[{ name }]} />;
};
